import * as React from "react";
function MdIcon() {
    return React.createElement("path", { d: "M4.37821 15.7493H5.47115L13 8.22046L11.9071 7.1275L4.37821 14.6564V15.7493ZM15.8189 7.31663L12.8189 4.30065L14.7212 2.39844L17.7291 5.4064L15.8189 7.31663ZM3.04492 17.0826V14.0827L11.8943 5.23331L14.8942 8.23327L6.04486 17.0826H3.04492Z", fill: "currentColor" });
}
export default MdIcon;
//# sourceMappingURL=Md.js.map